<template>
    <div>
        <form @submit.prevent="submit" v-if="!submitSuccess">
            <div class="row justify-content-center">
                <div class="col-11 col-sm-8 col-md-6 col-xl-4 px-1 px-md-0">
                    <div class="row justify-content-center renault-form">
                        <div class="col-10 col-sm-12 text-center mb-3">
                            <h2 class="text-white">
                                ¡Recibí las útimas novedades!
                            </h2>
                        </div>
                        <div class="col-6 col-lg-3 px-1 mb-3">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Nombre*"
                                id="first_name"
                                name="first_name"
                                aria-label="Nombre"
                                v-model="fields.first_name"
                            />
                        </div>
                        <div class="col-6 col-lg-3 px-1 mb-3">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Apellido*"
                                id="last_name"
                                name="last_name"
                                aria-label="Apellido"
                                v-model="fields.last_name"
                            />
                        </div>
                        <div class="col-lg-6 px-1 mb-3">
                            <input
                                type="text"
                                class="form-control"
                                placeholder="Medio*"
                                id="media"
                                name="media"
                                aria-label="Medio"
                                v-model="fields.media"
                            />
                        </div>
                        <div class="col-md-8 px-1 mb-3">
                            <input
                                type="email"
                                class="form-control"
                                placeholder="Email*"
                                id="email"
                                name="email"
                                aria-label="email"
                                v-model="fields.email"
                            />
                        </div>
                        <div class="col-md-4 px-1 mb-3">
                            <button
                                id="suscribe-mr"
                                type="submit"
                                class="btn btn-renault w-100"
                                :disabled="!agreeCheckBox"
                            >
                                Suscribirse
                            </button>
                        </div>
                        <div
                            class="col-12 col-sm-10 d-flex justify-content-center"
                        >
                            <div class="form-check form-switch renault-switch">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    id="agreeCheckbox"
                                    v-model="agreeCheckBox"
                                />
                                <label
                                    class="form-check-label text-white"
                                    for="agreeCheckbox"
                                    >Acepto recibir información de Renault
                                    Argentina.</label
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div v-if="submitSuccess">
            <div class="row justify-content-center">
                <div class="col-11 col-sm-8 col-md-6 col-xl-4 px-1 px-md-0">
                    <h2 class="text-white text-center">¡Te subscribiste con éxito!</h2>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            agreeCheckBox: false,
            fields: {},
            submitSuccess: false,
            errors: {},
        };
    },
    mounted() {

    },
    methods: {
        submit() {
            this.errors = {};
            axios
                .post(process.env.MIX_API_URL+"subscriber", this.fields)
                .then((response) => {
                    this.submitSuccess = true;
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response.status === 409 && error.response.data.redirect_url !== null) {
                        window.location.href = error.response.data.redirect_url
                    }
                });
        },
    },
};
</script>
